/**
 * Domain acronyms that must stay uppercase in any position. Compared against the
 * uppercased form of each word so input casing does not matter.
 */
const ACRONYMS: ReadonlySet<string> = new Set([
	"VOE",
	"VOD",
	"PMI",
	"API",
	"RESPA",
	"VOM",
]);

const SEPARATOR = /[\s_]+/;

/**
 * Renders an event-type enum value as a reader-friendly sentence-case label.
 *
 * Splits on underscores and whitespace, lowercases each word, capitalizes only
 * the first word, and keeps known acronyms uppercase regardless of position.
 *
 * @example humanizeEventType("LOAN_PAID_OFF") // "Loan paid off"
 * @example humanizeEventType("VOE_COMPLETED") // "VOE completed"
 * @example humanizeEventType("ORDER_PMI_API_PULLED") // "Order PMI API pulled"
 */
export function humanizeEventType(eventType: string): string {
	const words = eventType.split(SEPARATOR).filter((word) => word.length > 0);

	return words
		.map((word, index) => {
			const upper = word.toUpperCase();
			if (ACRONYMS.has(upper)) {
				return upper;
			}
			const lower = word.toLowerCase();
			if (index === 0) {
				return lower.charAt(0).toUpperCase() + lower.slice(1);
			}
			return lower;
		})
		.join(" ");
}
